import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { CampaignDrawerOpen } from './campaign-drawer.interface';

@Injectable({
    providedIn: 'root',
})
export class CampaignDrawerService {
    private _open = new BehaviorSubject<CampaignDrawerOpen | null>(null);
    get open() {
        return this._open.asObservable();
    }

    private _opened: any;
    get opened() {
        return this._opened;
    }

    constructor() {}

    setOpen(data: CampaignDrawerOpen) {
        this._opened = data;
        this._open.next(data);
    }
}
